import { Component, OnInit } from '@angular/core';
import { MenuComponent } from '../menu/menu.component';
import { ContenidoService } from '../contenido.service';

@Component({
  selector: 'app-policies-board',
  templateUrl: './policies-board.component.html',
  styleUrls: ['./policies-board.component.css',
    '../../assets/css/bootstrap.min.css',
    '../../assets/scss/styles.scss', 
    '../../assets/scss/general-pb.scss', 
    '../../assets/scss/fonts.scss',
    '../../assets/ema/main.scss', 
    ]
})
export class PoliciesBoardComponent implements OnInit {
  public contenido = this.contenidoService.getContenido("policies-board");
  constructor(private contenidoService: ContenidoService) {}

  ngOnInit() {
  }

}
